var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7075 16.7074L18.7075 25.7074C18.5199 25.8951 18.2654 26.0005 18 26.0005C17.7346 26.0005 17.4801 25.8951 17.2925 25.7074C17.1049 25.5198 16.9994 25.2653 16.9994 24.9999C16.9994 24.7346 17.1049 24.4801 17.2925 24.2924L24.5863 16.9999H5C4.73478 16.9999 4.48043 16.8946 4.29289 16.7071C4.10536 16.5195 4 16.2652 4 15.9999C4 15.7347 4.10536 15.4804 4.29289 15.2928C4.48043 15.1053 4.73478 14.9999 5 14.9999H24.5863L17.2925 7.70745C17.1049 7.5198 16.9994 7.26531 16.9994 6.99995C16.9994 6.73458 17.1049 6.48009 17.2925 6.29245C17.4801 6.1048 17.7346 5.99939 18 5.99939C18.2654 5.99939 18.5199 6.1048 18.7075 6.29245L27.7075 15.2924C27.8005 15.3853 27.8742 15.4956 27.9246 15.617C27.9749 15.7384 28.0008 15.8685 28.0008 15.9999C28.0008 16.1314 27.9749 16.2615 27.9246 16.3829C27.8742 16.5043 27.8005 16.6146 27.7075 16.7074Z",
    fill: "#F47920"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.3d5599ec8b14551962493caa83a56e10.svg";
export { ForwardRef as ReactComponent };